import httpClient from '@/http-client'
import { baseMutations, baseState } from '@/store/mixins'

const BASE_URL = '/api/payment/khqr'

export default {
  namespaced: true,
  state: {
    ...baseState,
    options: {
      branches: [],
      banks: []
    },
    config: null
  },
  mutations: {
    ...baseMutations,
    RECEIVE_OPTIONS(state, options) {
      state.options = {
        branches: options.branches || [],
        banks: options.banks || []
      }
    },
    RECEIVE_CONFIG(state, config) {
      state.config = config
    }
  },
  actions: {
    async fetch(context, attributes = {}) {
      const params = Object.assign(
        {
          page: context.state.pagination.currentPage,
          pageSize: context.state.pagination.perPage,
          search: context.state.search
        },
        attributes
      )
      const response = await httpClient.post(`${BASE_URL}/attempts/search`, params)
      context.commit('RECEIVE_RESOURCES', response.data)
      return response
    },
    async fetchConfig(context) {
      const response = await httpClient.get(`${BASE_URL}/attempts/config`)
      context.commit('RECEIVE_CONFIG', response.data.data || null)
      return response
    },
    async fetchOptions(context) {
      const [branches, banks] = await Promise.all([
        httpClient.get(`${BASE_URL}/attempts/options/branches`),
        httpClient.get(`${BASE_URL}/attempts/options/banks`)
      ])
      context.commit('RECEIVE_OPTIONS', {
        branches: branches.data.data || [],
        banks: banks.data.data || []
      })
      return { branches, banks }
    },
    find(context, id) {
      return httpClient.get(`${BASE_URL}/attempts/${id}`)
    },
    getEvents(context, id) {
      return httpClient.get(`${BASE_URL}/attempts/${id}/events`)
    },
    retryFulfillment(context, id) {
      return httpClient.post(`${BASE_URL}/attempts/${id}/retry-fulfillment`)
    }
  }
}
